const question6 = {
    'question': 'Kto udziela pomocy w przypadku interwencji kryzysowej?',
    'answer': 'Pomoc w przypadku interwencji kryzysowej udzielają specjaliści z różnych dziedzin. W Colligo oferujemy wykwalifikowanych psychologów oraz psychoterapeutów, którzy pomogą zdefiniować problem oraz udzielą potrzebnego wsparcia.',
}

export default question6;